export const strings = {
  PASSWORD_MATCH_ERROR: "Passwords must be same",

  WEAK_PASSWORD_ERROR:
    "Password should include at least one uppercase, one lowercase, one numeric and one special character.",
};
